import * as Features from '../../../../../../../shared/Features';
import * as PhotoStatus from '../../../../../../../shared/PhotoStatus';
import { AuthenticatedUser } from '../../../../../../../shared/types';

export function isImageProcessingReady(user: AuthenticatedUser, photoStatus: any): boolean {
    return (
        Features.hasFeature(Features.ViewEditedImages, user) ||
        (Features.hasFeature(Features.ViewDeliveredEditedImages, user) &&
            (photoStatus.currentStatus === PhotoStatus.Se360Approved ||
                photoStatus.currentStatus === PhotoStatus.CustomerApproved ||
                photoStatus.currentStatus === PhotoStatus.DeliveryStarted ||
                photoStatus.currentStatus === PhotoStatus.Delivered ||
                photoStatus.currentStatus === PhotoStatus.DeliveryError ||
                photoStatus.currentStatus === PhotoStatus.SetToRedeliver))
    );
}

export function showApproveImagesBox(photoStatus: number, user: AuthenticatedUser) {
    if (
        photoStatus < PhotoStatus.CustomerApproved &&
        Features.hasFeature(Features.ApproveImagesByCustomer, user)
    ) {
        return true;
    }

    return false;
}

let DELIVERY_ELIGIBLE_STATUSES = [
    PhotoStatus.CustomerApproved,
    PhotoStatus.Delivered,
    PhotoStatus.ScheduledForCustomerApproval,
    PhotoStatus.DeliveryStarted,
    PhotoStatus.DeliveryError,
    PhotoStatus.SetToRedeliver
];

export function showDeliveryOptions(photoStatus: number, user: AuthenticatedUser) {
    if (
        DELIVERY_ELIGIBLE_STATUSES.indexOf(photoStatus) !== -1 &&
        Features.hasFeature(Features.ApproveImagesByCustomer, user)
    ) {
        return true;
    }

    return false;
}
